import {
  Component,
  computed,
  effect,
  HostBinding,
  Signal,
  signal,
} from '@angular/core';
import { TPipe, TRANSLATION_PREFIX } from '@pipes/t.pipe';
import { AbbSimpleCardComponent } from '@components/abb-card/abb-simple-card.component';
import { AbbAvatarFieldComponent } from '@components/abb-form/abb-avatar-field.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AbbButtonComponent } from '@components/abb-button/abb-button.component';
import { Subscription } from 'rxjs';
import { Apollo } from 'apollo-angular';
import {
  AccountQuery,
  UpdateUserAvatarMutation,
  UpdateUserAvatarMutationVariables,
  UserAccount,
} from 'gql/graphql';
import {
  accountQuery,
  updateAccountUserMutation,
  updateUserAvatarMutation,
} from '@graphql/account';
import { OverlayService } from '@services/ui/overlay.service';
import { AccountModalComponent } from './account-modal/account-modal.component';
import { TransferDataModalComponent } from './transfer-data-modal/transfer-data-modal.component';
import { CognitoService, UserWithID } from '@services/cognito/cognito.service';
import { CommonModule } from '@angular/common';
import { ChangePswModalComponent } from './change-psw-modal/change-psw-modal.component';
import { DatePipe } from '@pipes/date-pipe.pipe';
import { getErrorMessage } from '@utils/errors';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@services/ui/toast.service';
import { CompanyService } from '@services/company/company-service.service';
import { UserSettingsService } from '@services/user/user-settings.service';

@Component({
  selector: 'abb-account',
  standalone: true,
  imports: [
    TPipe,
    DatePipe,
    CommonModule,
    AbbSimpleCardComponent,
    AbbAvatarFieldComponent,
    AbbButtonComponent,
    ReactiveFormsModule,
  ],
  template: `
    <div
      class="w-full h-auto grid grid-cols-1 lg:grid-cols-2 grid-flow-row-dense gap-2 pr-4"
    >
      <div class="col-span-1 p-4 flex flex-col gap-8">
        <abb-simple-card class="flex-1" [title]="'Profile Picture' | t">
          <div content class="w-full flex flex-col items-center justify-center">
            <abb-avatar-field [formControl]="imgUrl" class="self-center">
              <div
                avatarSuffix
                class="py-3 text-xs text-abb-font/80 font-medium uppercase text-center"
              >
                {{ 'Upload/Change Your Profile' | t }}
              </div>
            </abb-avatar-field>
          </div>
        </abb-simple-card>
      </div>
      <div class="col-span-1 p-4 flex flex-col gap-8">
        <abb-simple-card class="flex-1" [title]="'Account Details' | t">
          <div
            content
            class="flex-1 w-full flex flex-row gap-3 px-3 font-medium text-xs text-abb-font/80"
          >
            <div class="w-full flex flex-col flex-1 gap-1 justify-evenly">
              <div class="flex flex-row items-center gap-2">
                <span class="flex-1">{{ 'Name' | t }}</span>
                <span class="text-right" [style.word-break]="'break-word'">{{
                  userAccount()?.name
                }}</span>
              </div>
              <div class="flex flex-row items-center gap-2">
                <span class="flex-1">{{ 'Surname' | t }}</span>
                <span class="text-right" [style.word-break]="'break-word'">{{
                  userAccount()?.lastName
                }}</span>
              </div>
              <div class="flex flex-row items-center gap-2">
                <span class="flex-1">{{ 'Company / Legal Entity' | t }}</span>
                <span class="text-right" [style.word-break]="'break-word'">{{
                  currentCompany()
                }}</span>
              </div>
              <!-- <div class="flex flex-row items-center gap-2">
                <span class="flex-1">{{ 'Address' | t }}</span>
                <span
                  *ngIf="user()?.address! | jsonParse as parsedAddress"
                  class="text-right"
                  [style.word-break]="'break-word'"
                  >{{ parsedAddress?.street_address }}</span
                >
              </div> -->
              <div class="flex flex-row items-center gap-2">
                <span class="flex-1">{{ 'Phone' | t }}</span>
                <span class="text-right" [style.word-break]="'break-word'">{{
                  userAccount()?.phone
                }}</span>
              </div>
              <!-- <div class="flex flex-row items-center gap-2">
                <span class="flex-1">{{ 'Country' | t }}</span>
                <span
                  *ngIf="user()?.address! | jsonParse as parsedAddress"
                  class="text-right"
                  [style.word-break]="'break-word'"
                  >{{ parsedAddress?.country }}</span
                >
              </div>
              <div class="flex flex-row items-center gap-2">
                <span class="flex-1">{{ 'City' | t }}</span>
                <span
                  *ngIf="user()?.address! | jsonParse as parsedAddress"
                  class="text-right"
                  [style.word-break]="'break-word'"
                  >{{ parsedAddress?.locality }}</span
                >
              </div> -->
              <!-- <div class="flex flex-row items-center gap-2">
                <span class="flex-1">{{ 'Postal Code' | t }}</span>
                <span
                  *ngIf="user()?.address! | jsonParse as parsedAddress"
                  class="text-right"
                  [style.word-break]="'break-word'"
                  >{{ parsedAddress?.postalCode }}</span
                >
              </div> -->
              <div class="flex flex-row items-center gap-2">
                <span class="flex-1">{{ 'Email Address' | t }}</span>
                <span class="text-right" [style.word-break]="'break-word'">{{
                  userAccount()?.email
                }}</span>
              </div>
            </div>
          </div>
          <div
            footer
            class="flex flex-row flex-wrap gap-3 justify-center items-center pt-3"
          >
            <abb-button
              id="change-password-btn"
              (click)="openChangePswModal()"
              className="px-5 py-1 text-xs font-medium"
              >{{ 'Change Password' | t }}</abb-button
            >
            <abb-button
              id="change-details"
              (click)="openEditModal()"
              className="px-5 py-1 text-xs font-medium"
              >{{ 'Change Details' | t }}</abb-button
            >
          </div>
        </abb-simple-card>
      </div>
      <div class="col-span-1 p-4 flex flex-col gap-8">
        <abb-simple-card [title]="'License' | t">
          <div
            content
            class="min-h-36 w-full flex flex-row gap-3 px-3 font-medium text-xs text-abb-font/80"
          >
            <div class="flex flex-col flex-1 gap-1 justify-evenly">
              <div class="flex flex-row items-center gap-2">
                <span class="flex-1">{{
                  'Commissioning Activation Date' | t
                }}</span>
                <span class="text-right" [style.word-break]="'break-word'">{{
                  account()?.commissioningActivationDate | localDate
                }}</span>
              </div>
              <div class="flex flex-row items-center gap-2">
                <span class="flex-1">{{ 'Free Trial Activation' | t }}</span>
                <span class="text-right" [style.word-break]="'break-word'">{{
                  account()?.freeTrialActivationDate | localDate
                }}</span>
              </div>
              <div class="flex flex-row items-center gap-2">
                <span class="flex-1">{{ 'Current Status' | t }}</span>
                <span class="text-right" [style.word-break]="'break-word'">
                  {{ 'Under free trial period' | t }}
                </span>
              </div>
              <div class="flex-row items-center gap-2 hidden">
                <span class="flex-1">{{ 'Expiration date' | t }}</span>
                <span class="text-right" [style.word-break]="'break-word'">
                  {{
                    (account()?.expirationDate ?? undefined | localDate) ??
                      ('TDB' | t)
                  }}
                </span>
              </div>
            </div>
          </div>
          <div
            footer
            class="flex flex-row flex-wrap gap-3 justify-center items-center pt-3"
          >
            <abb-button
              id="renew-btn"
              className="px-5 py-1 text-xs font-medium hidden"
              >{{ 'Renew' | t }}</abb-button
            >
            <abb-button
              id="change-license-btn"
              className="px-5 py-1 text-xs font-medium hidden"
              >{{ 'Change License' | t }}</abb-button
            >
            @if(account()?.owner) {
            <abb-button
              id="transfer-data"
              (click)="openTransferDataModal()"
              className="px-5 py-1 text-xs font-medium"
              >{{ 'Transfer License' | t }}</abb-button
            >
            }
          </div>
        </abb-simple-card>
      </div>
    </div>
    <div class="flex flex-col items-center justify-center space-x-4">
      <p
        (click)="downloadTermsDocument($event)"
        class="underline text-xs text-abb-font/60 text-center cursor-pointer text-abb-primary hover:text-abb-primary/80 mt-4"
      >
        {{ 'terms & conditions' | t }}
      </p>
      <p
        class="text-xs text-abb-font/60 text-center mt-2"
        [innerHTML]="'privacy notice' | t"
      ></p>
    </div>
  `,
  styles: ``,
  providers: [
    {
      provide: TRANSLATION_PREFIX,
      useValue: 'settings.tabs.account',
    },
  ],
})
export class AccountComponent {
  @HostBinding('attr.id') componentid = 'account-component';
  imgUrl = new FormControl<string>('');
  user = signal<UserWithID | null>(null);
  userAccount = signal<UserAccount | null>(null);
  account = signal<AccountQuery['account'] | null>(null);
  loadingData = signal(true);
  loadingAvatar = signal(true);
  currentCompany = computed<string>(() => this.companyService.currentCompany());

  private subscriptions: Subscription[] = [];
  readonly userImageEffect: ReturnType<typeof effect>;
  constructor(
    readonly companyService: CompanyService,
    private readonly overlayService: OverlayService,
    private readonly apollo: Apollo,
    private readonly cognitoService: CognitoService,
    readonly toast: ToastService,
    readonly translate: TranslateService,
    readonly userService: UserSettingsService
  ) {
    this.user.set(cognitoService.loggedUser());
    this.userAccount.set(userService.userAccount());
    this.userImageEffect = effect(() => {
      const user = this.cognitoService.loggedInUser();
      const currentImgUrl = user?.imgUrl ?? '';

      if (this.imgUrl.value !== currentImgUrl) {
        this.imgUrl.setValue(currentImgUrl);
      }
    });
    this.imgUrl.setValue(this.user()?.imgUrl ?? '');
    this.subscriptions.push(
      apollo
        .watchQuery<AccountQuery>({
          query: accountQuery,
        })
        .valueChanges.subscribe({
          next: ({ data }) => {
            this.account.set(data.account);
            this.loadingData.set(false);
          },
          error: (err) => {
            //let errMsg = getErrorMessage(err, this.translate);
            //this.toast.notifyError(errMsg);
          },
        }),
      this.imgUrl.valueChanges.subscribe((value) => {
        if (value !== this.cognitoService.loggedInUser()?.imgUrl) {
          apollo
            .mutate<
              UpdateUserAvatarMutation,
              UpdateUserAvatarMutationVariables
            >({
              mutation: updateUserAvatarMutation,
              variables: {
                id: this.user()?.id ?? '',
                imgUrl: value ?? '',
              },
            })
            .subscribe({
              next: ({ data }) => {
                this.loadingAvatar.set(false);
                this.cognitoService.updateLoggedInUserImgUrl(
                  data?.updateUserAvatar ?? ''
                );
              },
              error: () => {
                this.loadingAvatar.set(false);
              },
            });
        }
      })
    );
  }

  openChangePswModal() {
    this.overlayService.openModal(ChangePswModalComponent, undefined);
  }
  downloadTermsDocument(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    const currentLang = this.translate.currentLang || 'en-EN';
    let documentPath = '';
    if (currentLang === 'it-IT') {
      documentPath = 'assets/terms_and_condtions/ABB Ability GTC-it.pdf';
    } else {
      documentPath = 'assets/terms_and_condtions/ABB Ability GTC-en.pdf';
    }

    const link = document.createElement('a');
    link.href = documentPath;
    link.download = `terms-conditions-${currentLang}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.open(documentPath, '_blank');
  }

  openEditModal() {
    const ref = this.overlayService.openModal(AccountModalComponent, {
      mode: 'edit',
      user: this.userAccount()!,
    });

    ref?.componentInstance?.userUpdated?.subscribe((formData: any) => {
      console.log('User update requested:', formData);

      this.apollo
        .mutate({
          mutation: updateAccountUserMutation,
          variables: {
            id: this.user()!.id,
            name: formData.name,
            lastName: formData.lastName,
            phone: formData.phone,
            email: formData.email,
            company: formData.company
          },
        })
        .subscribe({
          next: (result) => {
            console.log('User updated on backend:', result);

            this.userService.getUserAccount().then((account) => {
              this.userAccount.set(account);
            });

            this.apollo.client.refetchQueries({
              include: ['GetCompanyList'],
            });

            this.toast.notifySuccess(
              this.translate.instant('Account updated successfully.')
            );

            ref?.componentInstance.loading.set(false);
            ref?.componentInstance.modalRef?.dispose();
          },
          error: (err) => {
            console.error('Error updating user on backend:', err);
            this.toast.notifyError(
              this.translate.instant(
                'An error occurred while updating your account.'
              )
            );

            ref?.componentInstance.loading.set(false);
          },
        });
    });
  }

  openTransferDataModal() {
    this.overlayService.openModal(TransferDataModalComponent, {
      account: this.account()!,
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
    this.userImageEffect.destroy();
  }
}
